import { render, staticRenderFns } from "./StickerVideoPlayer.vue?vue&type=template&id=4240351c&scoped=true"
import script from "./StickerVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./StickerVideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./StickerVideoPlayer.vue?vue&type=style&index=0&id=4240351c&prod&lang=scss"
import style1 from "./StickerVideoPlayer.vue?vue&type=style&index=1&id=4240351c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240351c",
  null
  
)

export default component.exports